/* tslint:disable */
/* eslint-disable */
/**
 * Web MMB BFF API
 * Version of Backend for Frontend API (mid-layer between FE and MMB API) designed for web frontend purposes.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AlternativeSectorStopsInfoFromJSON, AlternativeSectorStopsInfoToJSON, } from './AlternativeSectorStopsInfo';
import { AlternativeSectorDurationFromJSON, AlternativeSectorDurationToJSON, } from './AlternativeSectorDuration';
import { AlternativeSectorStopFromJSON, AlternativeSectorStopToJSON, } from './AlternativeSectorStop';
import { SectorCarriersFromJSON, SectorCarriersToJSON, } from './SectorCarriers';
import { SectorVehicleTypesFromJSON, SectorVehicleTypesToJSON, } from './SectorVehicleTypes';
/**
 * @export
 */
export const AlternativeSectorSectorTypeEnum = {
    Default: 'default',
    Info: 'info',
    Warning: 'warning',
    Critical: 'critical',
    Success: 'success'
};
/**
 * Check if a given object implements the AlternativeSector interface.
 */
export function instanceOfAlternativeSector(value) {
    if (!('arrival' in value) || value['arrival'] === undefined)
        return false;
    if (!('departure' in value) || value['departure'] === undefined)
        return false;
    if (!('sectorType' in value) || value['sectorType'] === undefined)
        return false;
    return true;
}
export function AlternativeSectorFromJSON(json) {
    return AlternativeSectorFromJSONTyped(json, false);
}
export function AlternativeSectorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'arrival': AlternativeSectorStopFromJSON(json['arrival']),
        'carriers': json['carriers'] == null ? undefined : SectorCarriersFromJSON(json['carriers']),
        'departure': AlternativeSectorStopFromJSON(json['departure']),
        'duration': json['duration'] == null ? undefined : AlternativeSectorDurationFromJSON(json['duration']),
        'layoverInfo': json['layover_info'] == null ? undefined : AlternativeSectorStopsInfoFromJSON(json['layover_info']),
        'sectorNote': json['sector_note'] == null ? undefined : json['sector_note'],
        'sectorType': json['sector_type'],
        'vehicleTypes': json['vehicle_types'] == null ? undefined : SectorVehicleTypesFromJSON(json['vehicle_types']),
    };
}
export function AlternativeSectorToJSON(json) {
    return AlternativeSectorToJSONTyped(json, false);
}
export function AlternativeSectorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'arrival': AlternativeSectorStopToJSON(value['arrival']),
        'carriers': SectorCarriersToJSON(value['carriers']),
        'departure': AlternativeSectorStopToJSON(value['departure']),
        'duration': AlternativeSectorDurationToJSON(value['duration']),
        'layover_info': AlternativeSectorStopsInfoToJSON(value['layoverInfo']),
        'sector_note': value['sectorNote'],
        'sector_type': value['sectorType'],
        'vehicle_types': SectorVehicleTypesToJSON(value['vehicleTypes']),
    };
}
